{
  "Temporal coverage": "Temporal coverage",
  "Frequency": "Frequency",
  "Spatial coverage": "Spatial coverage",
  "Territorial coverage granularity": "Territorial coverage granularity",
  "resources": "resources",
  "reuses": "reuses",
  "favourites": "favourites",
  "Admin": "Admin",
  "Reply to the discussion": "Reply to the discussion",
  "Comment": "Comment",
  "Reply as": "Reply as",
  "Submit": "Submit",
  "Error sending response": "Error sending response",
  "Discussion closed": "Discussion closed",
  "messages": "messages",
  "Reply": "Reply",
  "The discussion was closed by": "The discussion was closed by",
  "on": "on",
  "Start a new discussion": "Start a new discussion",
  "New discussion": "New discussion",
  "Title": "Title",
  "Message": "Message",
  "You are seeing a specific discussion about this dataset": "You are seeing a specific discussion about this dataset",
  "See all discussions about this dataset": "See all discussions about this dataset",
  "Discussion creation": "Discussion creation",
  "Last reply": "Last reply",
  "An error occurred while fetching discussions": "An error occurred while fetching discussions",
  "An error occurred while fetching the discussion ": "An error occurred while fetching the discussion ",
  "An error occurred while creating the discussion ": "An error occurred while creating the discussion ",
  "There are no results for your search": "There are no results for your search",
  "from": "from",
  "to": "to",
  "Search...": "Search...",
  "Search for data...": "Search for data...",
  "Datasets": "Datasets",
  "Datasets-total": "datasets total",
  "Search reuses": "Search reuses",
  "Search filters": "Search filters",
  "Organizations": "Organizations",
  "Search an organization...": "Search an organization...",
  "Tags": "Tags",
  "Search a tag...": "Search a tag...",
  "Licenses": "Licenses",
  "Search a license...": "Search a license...",
  "Formats": "Formats",
  "Search a format...": "Search a format...",
  "Geographic area": "Geographic area",
  "Search a geographic area...": "Search a geographic area...",
  "Territorial granularity": "Territorial granularity",
  "Search a granularity...": "Search a granularity...",
  "Reset filters": "Reset filters",
  "No dataset matching your query": "No dataset matching your query",
  "You can try to reset the filters to expand your search.": "You can try to reset the filters to expand your search.",
  "Search for data, reuses, contributions...": "Search for data, reuses, contributions...",
  "Search all datasets": "Search all datasets",
  "See all datasets": "See all datasets",
  "Search in datasets": "Search in datasets",
  "Search in reuses": "Search in reuses",
  "See the reuses": "See the reuses",
  "No reuse matching your query": "No reuse matching your query",
  "No results found.": "No results found.",
  "Reuses": "Reuses",
  "Datasets are collections of data, i.e. structured information, easily readable by a machine.": "Datasets are collections of data, i.e. structured information, easily readable by a machine.",
  "Reuses refer to the use of data for an other purpose than the one they were produced for.": "Reuses refer to the use of data for an other purpose than the one they were produced for.",
  "Ask to join the organization as a producer": "Ask to join the organization as a producer",
  "You can add some details here for your membership request": "You can add some details here for your membership request",
  "A request has been sent to the administrators": "A request has been sent to the administrators",
  "Error while requesting membership": "Error while requesting membership",
  "Read more": "Read more",
  "Read less": "Read less",
  "remove from favorites": "remove from favorites",
  "add to favorites": "add to favorites",
  "Page": "Page {nb}",
  "First page": "First Page",
  "Previous page": "Previous page",
  "Next page": "Next page",
  "Last page": "Last page",
  "downloads": "downloads",
  "Nameless resource": "Nameless resource",
  "See more details": "See more details",
  "Preview": "Preview",
  "Copy permalink to clipboard": "Copy permalink to clipboard",
  "Resource link": "Resource link",
  "Download resource": "Download resource",
  "URL": "URL",
  "Permalink": "Permalink",
  "Type": "Type",
  "MIME Type": "MIME Type",
  "Created on": "Created on",
  "Modified on": "Modified on",
  "Published on": "Published on",
  "An error occurred while fetching resources": "An error occurred while fetching resources",
  "Edit resource": "Edit resource",
  "See schema": "See schema",
  "Associated schema": "Associated schema",
  "This resource is associated to the schema ": "This resource is associated to the schema ",
  "this means that the producer reports that it adheres to the specification.": "this means that the producer reports that it adheres to the specification.",
  "Documentation": "Documentation",
  "You can view the schema documentation, discover some context and recommendations for data producers.": "You can view the schema documentation, discover some context and recommendations for data producers.",
  "Read documentation": "Read documentation",
  "Validation": "Validation",
  "Resource validation based on a schema is a way to verify that the resource complies to the schema it is supposed to abide by. In case of errors, a validation report shows the errors found: wrongly named columns, non conform values, etc.": "Resource validation based on a schema is a way to verify that the resource complies to the schema it is supposed to abide by. In case of errors, a validation report shows the errors found: wrongly named columns, non conform values, etc.",
  "data.gouv.fr allows you to validate your files based on a schema and correct the possible errors.": "data.gouv.fr allows you to validate your files based on a schema and correct the possible errors.",
  "Validate resource": "Validate resource",
  "Others resources": "Others resources",
  "You can specify that a resource complies to a schema on your producer dashboard. Other resources complying with the schema are available on the platform.": "You can specify that a resource complies to a schema on your producer dashboard. Other resources complying with the schema are available on the platform.",
  "See dataset linked to this schema": "See dataset linked to this schema",
  "About schemas": "About schemas",
  "Data schemas allow to describe data models : what are the fields, how is data represented, what are the possible values. Discover how schemas improve data quality and use cases on ": "Data schemas allow to describe data models : what are the fields, how is data represented, what are the possible values. Discover how schemas improve data quality and use cases on ",
  "Available": "Available",
  "Unavailable": "Unavailable",
  "Close": "Close",
  "Copy permalink": "Copy permalink",
  "Discussions": "Discussions",
  "Error getting search results.": "Error getting search results.",
  "Sort discussions by": "Sort discussions by",
  "Private": "Private",
  "Unfeature this content": "Unfeature this content",
  "Feature this content": "Feature this content",
  "Preview of resource X": "Preview of resource {title}",
  "An error occurred while featuring this subject.": "",
  "Created date asc": "Created date asc",
  "Created date desc": "Created date desc",
  "Last modified asc": "Last modified asc",
  "Last modified desc": "Last modified desc",
  "Title asc": "Title asc",
  "Title desc": "Title desc",
  "Followers asc": "Followers asc",
  "Followers desc": "Followers desc",
  "Reuses asc": "Reuses asc",
  "Reuses desc": "Reuses desc",
  "Download datasets": "Download datasets",
  "Download resources": "Download resources",
  "sort by": "",
  "Documents": "Документа",
  "Documents and instructions": "Документа и упутства",
  "Law and by laws": "Закон и подзаконска акта",
  "Instructions": "Упутства",
  "Sort by": "",
  "Search by sort...": "Raspored prema..."
}